import Logger from "logger/logger"
import React, {useEffect} from "react"
import {Helmet, HelmetProvider} from "react-helmet-async"
import EnvironmentService, {subscribeEnv} from "app/Service/System/EnvironmentService"
import {langCca3To2} from "utils/langMapper"

function LanguageHelmet() {

  const {language} = EnvironmentService([
    subscribeEnv.language
  ], 'LanguageHelmet')

  useEffect(() => {
    Logger('Element.LanguageHelmet.init')
    return () => {
      Logger('Element.LanguageHelmet.unloading')
    }
  }, [])

  return undefined === language ? null : (
    <HelmetProvider>
      <Helmet>
        <html lang={langCca3To2(language)}/>
      </Helmet>
    </HelmetProvider>
  )
}

export default LanguageHelmet
